// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bem_a bhm_bj"};